// Class: openfl.filters.ShaderFilter

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function openfl_filters_BitmapFilter() {return require("./../../openfl/filters/BitmapFilter");}

// Constructor

var ShaderFilter = function(shader) {
	this.blendMode = "normal";
	(openfl_filters_BitmapFilter().default).call(this);
	this.shader = shader;
	this.__numShaderPasses = 1;
}

// Meta

ShaderFilter.__name__ = "openfl.filters.ShaderFilter";
ShaderFilter.__isInterface__ = false;
ShaderFilter.__super__ = (openfl_filters_BitmapFilter().default);
ShaderFilter.prototype = $extend((openfl_filters_BitmapFilter().default).prototype, {
	clone: function() {
		var filter = new ShaderFilter(this.shader);
		filter.set_bottomExtension(this.get_bottomExtension());
		filter.set_leftExtension(this.get_leftExtension());
		filter.set_rightExtension(this.get_rightExtension());
		filter.set_topExtension(this.get_topExtension());
		filter.blendMode = this.blendMode;
		return filter;
	},
	invalidate: function() {
		this.__renderDirty = true;
	},
	get_topExtension: function() {
		return this.__topExtension;
	},
	set_topExtension: function(value) {
		this.__topExtension = value;
		return this.__topExtension;
	},
	get_bottomExtension: function() {
		return this.__bottomExtension;
	},
	set_bottomExtension: function(value) {
		this.__bottomExtension = value;
		return this.__bottomExtension;
	},
	get_leftExtension: function() {
		return this.__leftExtension;
	},
	set_leftExtension: function(value) {
		this.__leftExtension = value;
		return this.__leftExtension;
	},
	get_rightExtension: function() {
		return this.__rightExtension;
	},
	set_rightExtension: function(value) {
		this.__rightExtension = value;
		return this.__rightExtension;
	},
	__initShader: function(renderer,pass,sourceBitmapData) {
		this.__shaderBlendMode = this.blendMode;
		return this.shader;
	}
});
ShaderFilter.prototype.__class__ = ShaderFilter.prototype.constructor = $hxClasses["openfl.filters.ShaderFilter"] = ShaderFilter;

// Init



// Statics


ShaderFilter.__meta__ = { fields : { blendMode : { SuppressWarnings : ["checkstyle:FieldDocComment"]}}}

// Export

exports.default = ShaderFilter;